module.exports = __webpack_public_path__ + "static/media/fitness-retreat-venue-icon.da71602b.svg";